/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/naming-convention */
import { getQueryParam } from './helper';
import {
  EmiPlans,
  ErrorPayload,
  KFSRespnse,
  PaymentAuthorizeResponse,
  PaymentFetchResponse,
} from './types';
import api from '@/api';
import { API_ENDPOINTS } from '@/constants';

export const fetchDetailsByPaymentId = async (): Promise<{
  success: boolean;
  data?: PaymentFetchResponse;
  error?: string;
}> => {
  const paymentId = getQueryParam('id');
  const response = await api(
    `${API_ENDPOINTS.PAYMENT_FETCH}/${paymentId}?with_gateway_merchant=true`,
    {},
    {
      method: 'GET',
    },
  );

  if (response.ok) {
    const data = (await response.json()) as PaymentFetchResponse;
    return {
      success: true,
      data,
    };
  }

  const error = (await response.json()) as ErrorPayload;

  return {
    success: false,
    error: error.message,
  };
};

export const updatePayment = async (status: {
  status?: string;
  failure_reason?: string;
  contact?: string;
}): Promise<{
  data: PaymentFetchResponse;
}> => {
  const paymentId = getQueryParam('id');
  const response = await api(
    `${API_ENDPOINTS.PAYMENT_FETCH}/${paymentId}`,
    {},
    {
      method: 'PATCH',
      body: JSON.stringify(status),
    },
  );

  return {
    data: (await response.json()) as unknown as PaymentFetchResponse,
  };
};

/**
 * Initiate Payment API
 */
export const initiatePayment = async (
  plan: EmiPlans,
): Promise<{
  success: boolean;
  error?: string;
}> => {
  const paymentId = getQueryParam('id') || '';
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.PAYMENT_INITIATE(paymentId)}`,
    {},
    {
      method: 'POST',
      body: JSON.stringify({
        plan_id: plan.plan_id,
        tenure: plan.tenure,
      }),
    },
  );

  const data = await response.json();

  if (response.ok) {
    return {
      success: true,
    };
  }

  return {
    success: false,
    error: (data as ErrorPayload).message,
  };
};

/**
 * Payment Authorize API
 */

export const authorizePayment = async ({
  otp,
}: {
  otp: string;
}): Promise<{
  data: PaymentAuthorizeResponse;
}> => {
  const paymentId = getQueryParam('id') || '';
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.PAYMENT_AUTHORIZE(paymentId)}`,
    {},
    {
      method: 'POST',
      body: JSON.stringify({
        otp,
      }),
    },
  );

  const res = await response.json();

  if (response.ok) {
    return {
      data: res as unknown as PaymentAuthorizeResponse,
    };
  }
  throw new Error((res as ErrorPayload).message);
};

export const fetchKfsStatement = async (): Promise<{
  data?: KFSRespnse;
  success?: boolean;
  error?: string;
}> => {
  const paymentId = getQueryParam('id') || '';
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.KFS_STATEMENT(paymentId)}`,
    {},
    {
      method: 'GET',
    },
  );

  const res = await response.json();

  if (response.ok) {
    return {
      data: res as unknown as KFSRespnse,
      success: true,
    };
  }
  return {
    success: false,
    error: (res as ErrorPayload).message,
  };
};

/**
 * API function to trigger resent otp for payment
 */
export const resendPaymentOTP = async (): Promise<{
  success: boolean;
  error?: string;
}> => {
  const paymentId = getQueryParam('id');
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.PAYMENT_OTP_RESEND(paymentId as string)}`,
    {},
    { method: 'POST' },
  );

  const data = await response.json();

  if (response.ok) {
    return {
      success: true,
    };
  }

  return {
    success: false,
    error: (data as ErrorPayload).message,
  };
};
